"use client";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/app/components/ui/select";
import Skeleton from "@/app/components/ui/skeleton";

export type ListingFilterSelectOptionT = {
  value: string;
  label: string;
};

type ListingFilterSelectPropsT = {
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
  label: string;
  options: ListingFilterSelectOptionT[];
  isLoading?: boolean;
  loadingItemCount?: number;
  onOpenChange?: (open: boolean) => void;
  onMouseEnter?: () => void;
};

export default function ListingFilterSelect({
  value,
  onValueChange,
  placeholder,
  label,
  options,
  isLoading = false,
  loadingItemCount = 3,
  onOpenChange,
  onMouseEnter,
}: ListingFilterSelectPropsT) {
  return (
    <Select
      value={value}
      onValueChange={onValueChange}
      onOpenChange={onOpenChange}
    >
      <SelectTrigger
        className="bg-background w-full truncate py-6"
        onMouseEnter={onMouseEnter}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>{label}</SelectLabel>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
          {isLoading &&
            Array.from({ length: loadingItemCount }).map((_, index) => (
              <Skeleton key={index} type="select_item" />
            ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
